import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/parentDirectory/${number | ':directoryParentId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/parentDirectory/:directoryParentId`;

export const URL = (jobId: number, directoryParentId: number): RouteDefinition => `${baseRoute}/${jobId}/parentDirectory/${directoryParentId}`;
